<template>
	<div style="margin-bottom: 15px">
		<div v-if="!isAdd">
			<el-card header="投保须知">
				<el-container ref="pdf" v-loading="isLoadingPdf" :style="setHeight" @touchmove.prevent>
					<el-main :style="!isCanScroll ? {overflow: 'hidden'} : {}" class="pdf-content">
						<el-alert :closable="false" style="margin-bottom: 10px" type="error">
							<span style="font-size: 1.25em; font-weight: bold">
								为保障您的合法权益，请您仔细阅读以下各部分内容，重要内容将以红色加粗字体为您标记，请务必知晓。如有疑问，请先联系客服人员确认无误后再行投保。
							</span>
						</el-alert>
						<div v-for="({fileType = '', url = ''}, index) in showDataList" :key="index" class="u-m-b-20">
							<div v-show="currentPosition === index">
								<!--富文本-->
								<div v-if="fileType === 'text'" v-html="url"></div>
								<!--图片-->
								<el-image v-else-if="fileType === 'png'" :src="url"></el-image>
								<div v-else-if="isShowPdf && fileType === 'pdf'">
									<pdf
										v-for="index in currentPdfPages"
										:key="index"
										:page="index"
										:src="url"
										style="margin-left: 160px; margin-right: 160px"
										@progress="onPdfProcess"
										@page-loaded="onOverReload"></pdf>
								</div>
							</div>
						</div>
						<div v-if="isShowPdf && (currentPdfPages > 0 || currentPosition === 0)" class="u-m-b-20">
							<!--页码-->
							<div class="customPage">{{ currentPosition + 1 }}/{{ showDataList.length }}</div>
							<div v-if="!isHideBtn" style="display: flex; justify-content: center">
								<el-button :disabled="currentPosition === 0" plain type="default" @click="onPageLast">上一页</el-button>
								<el-button :disabled="currentNum > 0" style="width: 140px" type="primary" @click="onPageNext">
									{{ currentNum > 0 ? `${currentNum}s后可关闭` : '我已逐条阅读并同意' }}
								</el-button>
							</div>
						</div>
					</el-main>
				</el-container>
			</el-card>

			<div v-if="!isShowPdf">
				<div v-for="({label, content: {files = []} = {}}, fileIndex) in protocolInfoData.tabs" :key="fileIndex">
					<el-card v-if="files.length > 0" :header="label" class="u-m-t-20">
						<div v-for="({fileType = '', url = '', name = ''}, pdfIndex) in files" :key="pdfIndex" class="link">
							<el-link v-if="fileType === 'pdf'" :href="url" target="_blank" type="primary">
								{{ name.replace('.pdf', '') }}
							</el-link>
							<el-image v-if="fileType === 'png'" :src="url"></el-image>
							<br />
						</div>
					</el-card>
				</div>
			</div>
			<el-card v-if="isHideBtn || !isShowPdf" class="u-m-t-20" header="投保人声明">
				<el-alert :closable="false" class="u-m-b-10" type="error">
					<span class="u-font-weight-bold u-font-14">为保障您的合法权益，请您仔细阅读后勾选确认</span>
				</el-alert>
				<el-row v-if="clickSureData || []" justify="start" type="flex">
					<el-checkbox-group v-model="checkListStatement">
						<el-checkbox
							v-for="(sureItem, sureIndex) in clickSureData"
							:key="sureIndex"
							:label="sureItem"
							class="u-m-b-10"></el-checkbox>
					</el-checkbox-group>
				</el-row>
				<el-row justify="center" style="margin-top: 5px" type="flex">
					<el-tag type="">
						<span class="u-font-weight-bold u-font-14">请滑动鼠标至底部，阅读并确认全部内容</span>
					</el-tag>
					<p></p>
				</el-row>
				<el-row justify="center" type="flex">
					<el-button v-if="isShowPdf" plain type="primary" @click="onBackInsured">查看投保须知</el-button>
					<el-button :disabled="!onSureAble" type="primary" @click="onStepConfirm">我已逐条阅读并同意投保</el-button>
				</el-row>
			</el-card>
		</div>
		<div v-else class="u-flex u-row-center u-m-t-20">
			<el-button type="primary" @click="onStepConfirm">同意投保</el-button>
		</div>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'
import pdf from 'vue-pdf'
import {isMeiYa} from '@/util/productUtil'

export default {
	name: 'insureNoticesTags',
	mixins: [],
	components: {pdf},
	props: {
		protocolInfoData: {
			type: Object,
			required: true,
			default: () => {
				return {
					tabs: [],
				}
			},
		},
		productId: String | Number,
		sourceProductId: String | Number,
		insureType: String | Number,
		isAdd: Boolean,
		isCanScroll: Boolean,
	},
	data() {
		return {
			currentPosition: 0,
			isLoadingPdf: false,
			currentPdfPages: 0,
			currentPdfUrl: '',
			isHideBtn: false,
			clickable: null,
			currentNum: '我已逐条阅读并同意',
			checkListStatement: [],
			isShowPdf: false,
			//循环展示的数据
			showDataList: [],
			//点击下一步确认按钮数据
			clickSureData: [],
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
		setHeight() {
			if (!this.isShowPdf) {
				return ''
			}
			return {height: '660px'}
		},
		//是否可点击
		onSureAble() {
			return this.checkListStatement.length > 0 && this.checkListStatement.length >= this.clickSureData.length
		},
	},
	watch: {
		protocolInfoData: {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal)) {
					let {tabs = []} = newVal
					//处理pDF
					this.showDataList = []
					for (let i = 0; i < tabs.length; i++) {
						let {content: {text = '', files = [], check: {content: contentCheck = []} = {}} = {}, ...otherData} =
							tabs[i]
						if (text) {
							this.showDataList.push(Object.assign({url: text, fileType: 'text'}, otherData))
						} else if (files.length > 0) {
							for (let j = 0; j < files.length; j++) {
								this.showDataList.push(Object.assign(files[j], otherData))
							}
						} else if (contentCheck.length > 0) {
							//投保人声明
							this.clickSureData = this.clickSureData.concat(contentCheck)
						}
					}
				}
			},
			immediate: true,
		},
	},
	created() {},
	mounted() {
		//判断是否需要PDF
		if (this.envConfig.isBxIe()) {
			this.isShowPdf = !isMeiYa(this.insureType)
		}
	},
	methods: {
		onPageLast() {
			if (this.currentPosition > 0) {
				this.currentPosition--
			}
			this.loadingPdf()
			this.$nextTick(() => {
				this.onScrollToPos()
			})
			this.currentNum = 6
			if (this.clickable) {
				clearInterval(this.clickable)
				this.clickable = null
			}
			this.setClickable()
		},
		onPageNext() {
			if (this.currentPosition < this.showDataList.length - 1) {
				this.currentPosition++
				this.loadingPdf()
				this.$nextTick(() => {
					this.onScrollToPos()
				})
			} else {
				//全部阅读完
				this.isHideBtn = true
				this.$emit('onInsureReadOver', false)
			}
			this.currentNum = 6
			this.setClickable()
		},
		//滑动
		onScrollToPos() {
			let main = document.getElementsByClassName('pdf-content')[0]
			if (main) {
				main.scrollTo({
					top: 0,
					behavior: 'smooth',
				})
			}
		},
		loadingPdf() {
			if (this.currentPosition >= 0) {
				//是否加载PDF
				let {fileType = ''} = this.showDataList[this.currentPosition]
				if (!this.isShowPdf || fileType !== 'pdf') {
					return
				}
				this.isLoadingPdf = true
				this.currentPdfUrl = pdf.createLoadingTask({
					url: this.showDataList[this.currentPosition].url,
					// 引入pdf.js字体，修复不显示
					cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
					cMapPacked: true,
				})
				let promiseData = this.currentPdfUrl.promise
				if (promiseData) {
					promiseData
						.then((pdf) => {
							let tempCanvas = document.getElementsByTagName('canvas')
							if (tempCanvas && tempCanvas.length > 0) {
								for (let tempcanva of tempCanvas) {
									tempcanva.setAttribute('state', 'loading')
								}
							}
							this.currentPdfPages = pdf.numPages
							setTimeout(() => {
								// pdf总页数
								this.isLoadingPdf = false
							}, 400 * this.currentPdfPages)
						})
						.catch((error) => {
							console.error(error)
						})
				}
			}
		},
		onBackInsured() {
			//返回查看
			this.isHideBtn = false
			this.$emit('onInsureReadOver', this.isHideBtn)
			this.onScrollToPos()
		},
		//倒计时3秒后可点击
		setClickable() {
			if (this.clickable) {
				return
			}
			this.clickable = setInterval(() => {
				this.currentNum--
				if (this.currentNum <= 0) {
					clearInterval(this.clickable)
					this.clickable = null
				}
			}, 1000)
		},
		onPdfProcess(num) {},
		onOverReload(num) {
			let tempCanvas = document.getElementsByTagName('canvas')
			this.$nextTick(() => {
				setTimeout(() => {
					if (tempCanvas.length > 0 && num <= tempCanvas.length) {
						tempCanvas[num - 1].setAttribute('state', 'rendered')
					}
				}, 1000)
			})
		},
		onStepConfirm() {
			//最后确认！！！
			this.$emit('onFirstStepConfirm')
		},
		//mock
		onSetNoticesMockData() {
			if (this.isShowPdf) {
				this.isHideBtn = true
				this.checkListStatement = [1, 2]
			}
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
.customPage {
	display: flex;
	justify-content: center;
	font-size: 26px;
	font-weight: bold;
}

.title_bold_custom {
	font-weight: bold;
}

.title_bold {
	font-size: 20px;
	font-weight: bold;
	margin: 15px 0 10px;
	text-align: center;
}

.insure_confirm {
	font-size: 15px;
	line-height: 28px;
	white-space: pre-line;
}

::v-deep .el-checkbox__label {
	display: inline-grid;
	width: 100%;
	white-space: pre-line;
	word-wrap: break-word;
}
</style>
